import { createApp } from 'vue';
import App from '@/App.vue';
import initErrorTracker from '@/utility/errorTracker';
import { env } from '@/utility';
import '@/styles/main.scss';
import '@nsftx/seven-components/style';
import '@nsftx/seven-components/palettes/default';

const app = createApp(App);

const startApp = () => {
  const isLocalDevelopment = window.location.hostname === 'localhost';
  const shouldInitErrorTracker = !isLocalDevelopment && env.errorTrackerActive === 'true';

  if (shouldInitErrorTracker) {
    initErrorTracker(app);
  }

  app.mount('#app');
};

startApp();
